import React, { useState, useRef, useEffect } from "react";

function PosterImage({ src, className = "", ...rest }) {
    const [isVisible, setIsVisible] = useState(false);
    const [hasLoaded, setHasLoaded] = useState(false);
    const imgRef = useRef(null);

    const checkYoutubeImage = (event) => {
        if (event.target.naturalWidth === 120) {
            event.target.src = event.target.currentSrc.replace("maxresdefault", "sddefault");
        }
        setHasLoaded(true);
    };

    useEffect(() => {
        if (!src) return;

        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting && hasLoaded) {
                    setIsVisible(true);
                    observer.disconnect(); // Trigger only once
                }
            },
            { threshold: 0.1 },
        );

        if (imgRef.current) observer.observe(imgRef.current);

        return () => {
            if (imgRef.current) observer.unobserve(imgRef.current);
        };
    }, [hasLoaded, src]);

    if (!src) return null;

    return (
        <img
            ref={imgRef}
            src={src}
            onLoad={checkYoutubeImage}
            className={`object-cover poster-image ${isVisible ? "fade-in" : ""} ${className}`}
            {...rest}
        />
    );
}

export default PosterImage;
